<section *ngIf="stockType === 'stock'">
   <h2 class="key-heading mb-0 fw-600">Key Statistics of {{stock.companyProfile.name}} ({{stock.companyProfile.ticker}})</h2>
   <p class="description_seo">
      Key statistics in the stock market are essential financial indicators that
      measure a company's performance, valuation, profitability, and risk.
   </p>

   <div
      class="range-grid"
      [ngClass]="{ 'single-card-mode': fundamentals?.isMainTicker === 0 }"
   >
      <div
         class="range_grid_inner"
         [ngClass]="{ 'single-card': fundamentals?.isMainTicker === 0 }"
      >
         <div class="fundamentals__chart" *ngIf="fundamentals?.todaysHigh">
            <p class="title_card">Today's Range</p>
            <div class="bar__chart rounded-pill">
               <!-- <div class="bar__chart_slider" [ngStyle]="{width: fundamentals?.todaysPercent + '%'}"></div> -->
               <svg
                  class="marker"
                  [ngStyle]="{ left: fundamentals?.todaysPercent + '%' }"
                  width="12"
                  height="20"
                  viewBox="0 0 12 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
               >
                  <circle
                     cx="5.84475"
                     cy="14.1533"
                     r="5.11416"
                     fill="#1BAD4E"
                     stroke="white"
                     stroke-width="1.46119"
                  />
                  <path
                     d="M5.84315 9.04297L9.63943 2.46763C9.63943 -0.820045 2.04688 -0.820045 2.04688 2.46763L5.84315 9.04297Z"
                     fill="#1BAD4E"
                  />
               </svg>
            </div>
            <div class="bar__numbers">
               <span>{{
                  (fundamentals?.todaysLow ? fundamentals?.todaysLow : 0)
                     | sumPipe : currency || ""
               }}</span>
               <span>{{
                  (fundamentals?.todaysHigh ? fundamentals?.todaysHigh : 0)
                     | sumPipe : currency || ""
               }}</span>
            </div>
         </div>

         <div
            class="fundamentals__other d-flex align-items-center justify-content-between"
         >
            <p class="mb-0">Today's Open</p>
            <span
               *ngIf="
                  (fundamentals && fundamentals?.todaysOpen == 0) ||
                  !fundamentals?.todaysOpen
               "
               >-</span
            >
            <span *ngIf="fundamentals && fundamentals?.todaysOpen > 0">
               {{
                  (fundamentals?.todaysOpen ? fundamentals?.todaysOpen : 0)
                     | sumPipe : currency || ""
               }}
            </span>
         </div>

         <div
            class="fundamentals__other d-flex align-items-center justify-content-between"
         >
            <p class="mb-0">Volume</p>
            <span
               *ngIf="
                  (fundamentals && fundamentals?.volume == 0) ||
                  !fundamentals?.volume
               "
               >-</span
            >
            <span *ngIf="fundamentals && fundamentals?.volume > 0">
               {{
                  (fundamentals?.volume ? fundamentals?.volume : 0)
                     | millionPipe
               }}
            </span>
         </div>

         <div
            class="fundamentals__other d-flex align-items-center justify-content-between"
         >
            <p class="mb-0">P/E Ratio (TTM)</p>
            <span *ngIf="fundamentals?.peAnnual == 0 || !fundamentals?.peAnnual"
               >-</span
            >
            <span *ngIf="fundamentals?.peAnnual > 0">
               {{
                  (fundamentals?.peAnnual ? fundamentals?.peAnnual : 0)
                     | currency : "" : ""
               }}
            </span>
         </div>
      </div>

      <div class="range_grid_inner" *ngIf="fundamentals?.isMainTicker !== 0">
         <div
            class="fundamentals__chart"
            *ngIf="fundamentals?.fiftyTwoWeekHigh"
         >
            <p class="title_card">52 Week Range</p>
            <div class="bar__chart">
               <!-- <span [ngStyle]="{left: fundamentals?.fiftyTwoWeekPercent + '%'}"></span> -->
               <!-- <div class="bar__chart_slider" [ngStyle]="{width: fundamentals?.fiftyTwoWeekPercent + '%'}"></div> -->

               <svg
                  class="marker"
                  [ngStyle]="{ left: fundamentals?.fiftyTwoWeekPercent + '%' }"
                  width="12"
                  height="20"
                  viewBox="0 0 12 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
               >
                  <circle
                     cx="5.84475"
                     cy="14.1533"
                     r="5.11416"
                     fill="#1BAD4E"
                     stroke="white"
                     stroke-width="1.46119"
                  />
                  <path
                     d="M5.84315 9.04297L9.63943 2.46763C9.63943 -0.820045 2.04688 -0.820045 2.04688 2.46763L5.84315 9.04297Z"
                     fill="#1BAD4E"
                  />
               </svg>
            </div>
            <div class="bar__numbers">
               <span>{{
                  (fundamentals?.fiftyTwoWeekLow
                     ? fundamentals?.fiftyTwoWeekLow
                     : 0
                  ) | sumPipe : currency || ""
               }}</span>
               <span>{{
                  (fundamentals?.fiftyTwoWeekHigh
                     ? fundamentals?.fiftyTwoWeekHigh
                     : 0
                  ) | sumPipe : currency || ""
               }}</span>
            </div>
         </div>

         <div
            class="fundamentals__other d-flex align-items-center justify-content-between"
         >
            <p class="mb-0">Market Cap</p>
            <span
               *ngIf="
                  (stock.companyProfile?.exchangeMarketCap &&
                     stock.companyProfile?.exchangeMarketCap == 0) ||
                  !stock.companyProfile?.exchangeMarketCap
               "
               >-</span
            >
            <span
               *ngIf="
                  stock.companyProfile?.exchangeMarketCap &&
                  stock.companyProfile?.exchangeMarketCap > 0
               "
            >
               {{
                  (stock.companyProfile?.exchangeMarketCap
                     ? stock.companyProfile?.exchangeMarketCap
                     : 0
                  ) | millionPipe : true
               }}
            </span>
         </div>

         <div
            class="fundamentals__other d-flex align-items-center justify-content-between"
         >
            <p class="mb-0">Avg. Volume</p>
            <span
               *ngIf="
                  (fundamentals && fundamentals?.averageVolume == 0) ||
                  !fundamentals?.averageVolume
               "
               >-</span
            >
            <span *ngIf="fundamentals && fundamentals?.averageVolume > 0">
               {{
                  (fundamentals?.averageVolume
                     ? fundamentals?.averageVolume
                     : 0
                  ) | millionPipe
               }}
            </span>
         </div>

         <div
            class="fundamentals__other d-flex align-items-center justify-content-between"
         >
            <p class="mb-0">Dividend Yield</p>
            <span>{{
               fundamentals?.dividendYield
                  ? (fundamentals?.dividendYield | number : "1.2-2") + "%"
                  : "-"
            }}</span>
         </div>
      </div>
   </div>
</section>

<section *ngIf="stockType === 'etf'">
   <h4 class="key-heading fw-600">Key Statistics of {{ etf?.etfProfileInfo?.name }} ({{ etf?.etfProfileInfo?.symbol }})</h4>

   <div class="range-grid">
      <div>
         <div class="fundamentals__chart" *ngIf="fundamentals?.todaysHigh">
            <p>Today's Range</p>
            <div class="bar__chart rounded-pill">
               <svg
                  class="marker"
                  [ngStyle]="{ left: fundamentals?.todaysPercent + '%' }"
                  width="12"
                  height="20"
                  viewBox="0 0 12 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
               >
                  <circle
                     cx="5.84475"
                     cy="14.1533"
                     r="5.11416"
                     fill="#1BAD4E"
                     stroke="white"
                     stroke-width="1.46119"
                  />
                  <path
                     d="M5.84315 9.04297L9.63943 2.46763C9.63943 -0.820045 2.04688 -0.820045 2.04688 2.46763L5.84315 9.04297Z"
                     fill="#1BAD4E"
                  />
               </svg>
            </div>
            <div class="bar__numbers">
               <span>{{
                  (fundamentals?.todaysLow ? fundamentals?.todaysLow : 0)
                     | sumPipe : currency || ""
               }}</span>
               <span>{{
                  (fundamentals?.todaysHigh ? fundamentals?.todaysHigh : 0)
                     | sumPipe : currency || ""
               }}</span>
            </div>
         </div>

         <div
            class="fundamentals__other d-flex align-items-center justify-content-between"
         >
            <p class="mb-0">Today's Open</p>
            <span
               *ngIf="
                  (fundamentals && fundamentals?.todaysOpen == 0) ||
                  !fundamentals?.todaysOpen
               "
               >-</span
            >
            <span *ngIf="fundamentals && fundamentals?.todaysOpen > 0">
               {{
                  (fundamentals?.todaysOpen ? fundamentals?.todaysOpen : 0)
                     | sumPipe : currency || ""
               }}
            </span>
         </div>

         <div
            class="fundamentals__other d-flex align-items-center justify-content-between"
         >
            <p class="mb-0">AUM</p>
            <span
               *ngIf="
                  (etf && etf.etfProfileInfo?.aum == 0) ||
                  (etf && !etf.etfProfileInfo?.aum)
               "
               >-</span
            >
            <span *ngIf="etf && etf.etfProfileInfo?.aum > 0">
               {{ etf?.etfProfileInfo?.aum | currencyMilion : currency : false }}
            </span>
         </div>

         <div
            class="fundamentals__other d-flex align-items-center justify-content-between"
         >
            <p class="mb-0">Avg. Volume</p>
            <span
               *ngIf="
                  (fundamentals && fundamentals.averageVolume == 0) ||
                  !fundamentals?.averageVolume
               "
               >-</span
            >
            <span *ngIf="fundamentals && fundamentals?.averageVolume > 0">
               {{
                  (fundamentals?.averageVolume
                     ? fundamentals?.averageVolume
                     : 0
                  ) | millionPipe
               }}
            </span>
         </div>
      </div>

      <div>
         <div
            class="fundamentals__chart"
            *ngIf="fundamentals?.fiftyTwoWeekHigh"
         >
            <p>52 Week Range</p>
            <div class="bar__chart">
               <svg
                  class="marker"
                  [ngStyle]="{ left: fundamentals?.fiftyTwoWeekPercent + '%' }"
                  width="12"
                  height="20"
                  viewBox="0 0 12 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
               >
                  <circle
                     cx="5.84475"
                     cy="14.1533"
                     r="5.11416"
                     fill="#1BAD4E"
                     stroke="white"
                     stroke-width="1.46119"
                  />
                  <path
                     d="M5.84315 9.04297L9.63943 2.46763C9.63943 -0.820045 2.04688 -0.820045 2.04688 2.46763L5.84315 9.04297Z"
                     fill="#1BAD4E"
                  />
               </svg>
            </div>
            <div class="bar__numbers">
               <span>{{
                  (fundamentals?.fiftyTwoWeekLow
                     ? fundamentals?.fiftyTwoWeekLow
                     : 0
                  ) | sumPipe : currency || ""
               }}</span>
               <span>{{
                  (fundamentals?.fiftyTwoWeekHigh
                     ? fundamentals?.fiftyTwoWeekHigh
                     : 0
                  ) | sumPipe : currency || ""
               }}</span>
            </div>
         </div>

         <div
            class="fundamentals__other d-flex align-items-center justify-content-between"
         >
            <p class="mb-0">Expense Ratio</p>
            <span
               *ngIf="
                  (etf && etf.etfProfileInfo?.expenseRatio == 0) ||
                  (etf && !etf.etfProfileInfo?.expenseRatio)
               "
               >-</span
            >
            <span *ngIf="etf && etf.etfProfileInfo?.expenseRatio > 0">
               {{ etf?.etfProfileInfo?.expenseRatio | currency : "" : "" }}%
            </span>
         </div>

         <div
            class="fundamentals__other d-flex align-items-center justify-content-between"
         >
            <p class="mb-0">P/E Ratio</p>
            <span
               *ngIf="
                  (etf && etf.etfProfileInfo?.priceToEarnings == 0) ||
                  (etf && !etf.etfProfileInfo?.priceToEarnings)
               "
               >-</span
            >
            <span *ngIf="etf && etf.etfProfileInfo?.priceToEarnings > 0">
               {{ etf?.etfProfileInfo?.priceToEarnings | currency : "" : "" }}
            </span>
         </div>

         <div
            class="fundamentals__other d-flex align-items-center justify-content-between"
         >
            <p class="mb-0">P/B Ratio</p>
            <span
               *ngIf="
                  (etf && etf.etfProfileInfo?.priceToBook == 0) ||
                  (etf && !etf.etfProfileInfo?.priceToBook)
               "
               >-</span
            >
            <span *ngIf="etf && etf.etfProfileInfo?.priceToBook > 0">
               {{ etf?.etfProfileInfo?.priceToBook | currency : "" : "" }}
            </span>
         </div>
      </div>
   </div>
</section>
